module.exports = __webpack_public_path__ + "static/media/icon-crown-02.a15d3c91.svg";